const trimURL = (url: string) => url.replace('https://', '').replace('www.', '');

const getExternalUrl = (url: string) => {
    return url.startsWith('www.') ? `https://${url}` : url;
};

const openInNewTab = (link: string) => {
    window.open(getExternalUrl(link), '_blank', 'noopener,noreferrer');
};

const isDomain = (url: string, domain: string) => {
    return (
        url.startsWith(domain) ||
        url.startsWith(`https://${domain}`) ||
        url.startsWith(`https://www.${domain}`) ||
        url.startsWith(`www.${domain}`)
    );
};
export { openInNewTab, trimURL, isDomain, getExternalUrl };
